import { createStyles, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';
import * as React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { ResultFileState } from './ConfigFormData';
import WarningIcon from '@material-ui/icons/Warning';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import { NavigatorData } from './NavigatorData';
import { NavLink } from 'react-router-dom';
import { Themes } from '../styling/Themes';
import { DeltaXMLColors } from '../styling/DeltaColors';


export interface ResultFileIconProps extends WithStyles<typeof styles> {
  state: ResultFileState
}

const styles = (theme: Theme) =>
  createStyles({
    errorIcon: {
      color: DeltaXMLColors.RED
    },
    checkIcon: {
      color: DeltaXMLColors.CELERY
    },
    warningIcon: {
      color: DeltaXMLColors.ORANGE
    },
  });


function ResultFileIcon(props: ResultFileIconProps) {

  const { state, classes } = props;

  let errorHeading = ""
  let errorDetail: JSX.Element | null = null;
  let iconElement: JSX.Element;
  ;
  switch (state) {
    case ResultFileState.completedOk:
      iconElement = <CheckCircleIcon className={classes.checkIcon} />;
      errorHeading = "Completed OK";
      break;
    case ResultFileState.completedOkButStale:
      iconElement = <WarningIcon className={classes.warningIcon} />;
      errorHeading = "Result file is out of sync with the configuration";
      break;
    case ResultFileState.failedToComplete:
      iconElement =
        <NavLink to={NavigatorData.logsBaseUrl} style={{ textDecoration: 'none' }}>
          <ErrorIcon className={classes.errorIcon} />
    </NavLink>
      errorHeading = "Previous operation failed";
      errorDetail = <>Click on the icon to view the logs</>;
      break;
    case ResultFileState.inProgress:
      iconElement = <HourglassEmptyIcon />;
      errorHeading = "Operation still in progress";
      break;
    case ResultFileState.initial:
      iconElement = <DonutLargeIcon />;
      errorHeading = "Operation not yet run"
      break;
  }

  return (
    <Themes.HtmlTooltip
      arrow
      title={
        <React.Fragment>
          <Typography color="inherit" variant="body2">{errorHeading}</Typography>
          {errorDetail}
        </React.Fragment>
      }>
      {iconElement}
    </Themes.HtmlTooltip>
  )
}

export default withStyles(styles)(ResultFileIcon);